module.exports = __webpack_public_path__ + "2a5f53b80e2979d15c18dfdc087fbd5b.svg";